export default function Logo({ light = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg width="36" height="36" viewBox="0 0 64 64" fill="none" aria-hidden="true" className="shrink-0">
        <defs>
          <linearGradient id="lkth-g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#3B82F6" />
            <stop offset="1" stopColor="#2563EB" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="60" height="60" rx="16" fill={light ? "#0B1F3A" : "#0B1F3A"} stroke="rgba(255,255,255,0.14)" />
        <path d="M43.5 20.5 A 16.5 16.5 0 1 0 43.5 43.5" fill="none" stroke="url(#lkth-g)" strokeWidth="7" strokeLinecap="round" />
        <circle cx="44" cy="32" r="5" fill="#FFFFFF" />
      </svg>
      <span className={`font-display leading-none ${light ? "text-white" : "text-[#0B1F3A]"}`}>
        <span className="text-lg font-bold tracking-tight">LKTH</span>
        <span className="ml-1 text-[11px] font-medium tracking-[0.28em] opacity-70">LTD</span>
      </span>
    </span>
  );
}
